const GLOBAL_URL = 'us.img.e-planning.net';
const DATA_ATTR = 'data-adpos';

const createIframe = () => {
    var el = document.createElement('IFRAME');
    el.src = 'about:blank';
    el.id = 'epl4iframe';
    el.name = 'epl4iframe';
    el.width = 0;
    el.height = 0;
    el.style.width = '0px';
    el.style.height = '0px';
    el.style.display = 'none';
    return el;
}

const findSite = (sites, width=document.body.offsetWidth) => {
    const selectedSites = sites
        .filter(s => s.maxWidth >= width)
        .sort((a, b) => a.maxWidth - b.maxWidth);

    if (selectedSites.length < 1) throw new Error(`No se encuentra un sitio para el ancho: ${width}`);

    return selectedSites[0];
}

export default class EplAd {
    constructor(sites, keywords = '', args = {}) {
        const protocol = document.location.protocol || window.top.location.protocol;
        this.scheme = protocol.substr(0, protocol.length - 1);
        this.sites = sites;
        this.args = args;
        this.keywords = keywords;

        this.site = findSite(sites);
        this.eplArgs = this._getArgs(this.site, args);
        
        this._loaded = false;
    }

    updateAds(forced=false) {
        if (!document.epl) return;
        const site = findSite(this.sites);
        if (forced || site !== this.site) {
            this.site = site;
            this.eplArgs = this._getArgs(this.site, this.args);
            this.removeSpaces();
            document.epl.eplInit(this.eplArgs);
            this.initSpaces();
        }
    }

    _getArgs(site, args = {}) {
        return Object.assign({
            iIF: 1,
            sV: `${this.scheme}://ads.e-planning.net/`,
            vV: "4",
            sOpts: {},
            sI: site.id,
            sec: site.section,
            eIs: site.positions,
            kVs: { busqueda: this.keywords }
        }, args);
    }

    initSpace(id) {
        const container = document.querySelector(`[${DATA_ATTR}="${id}"]`);
        this._initSpace(container);
    }

    initSpaces() {
        const ads = document.querySelectorAll(`[${DATA_ATTR}]`);
        for (let i = 0; i < ads.length; i++) {
            const container = ads[i];
            this._initSpace(container);
        }
    }

    removeSpace(id) {
        if (!document.epl) return;

        id = this._findPosition(id);
        const space = document.epl.getSpace(id);
        try {
            space.clearAds();
            space.getDiv().remove();
        } catch (_) {}
    }

    removeSpaces() {
        if (!document.epl) return;

        for (let name in document.epl.spaces) {
            const space = document.epl.spaces[name];
            try {
                space.clearAds();
                space.getDiv().remove();
            } catch (_) {}
        }
        const ads = document.querySelectorAll(`[${DATA_ATTR}]`);
        for (let i = 0; i < ads.length; i++) {
            const container = ads[i];
            container.childNodes.forEach(n => n.remove());
        }
    }

    reloadSpaces() {
        document.epl.refreshAds();
    }

    _findPosition(pos) {
        if (this.site.rename) {
            for (let i = 0; i < this.site.rename.length; i++) {
                const rn = this.site.rename[i];
                if (rn.from === pos) {
                    return rn.to;
                }
            }
        }
        return pos;
    }

    _initialized() {
        if (document.epl) return this._setupAd();
        if (this._loaded) return false;
        this._loaded = true;

        const cookie = document.cookie;
        const cookieName = ('https' === this.scheme ? 'EPLSERVER_S' : 'EPLSERVER') + '=';
        const regex = new RegExp(`${cookieName}[\\w.-]+`);

        let baseUrl = null;
        const res = regex.exec(cookie);
        if (res) {
            baseUrl = res[0].substr(cookieName.length);
        }

        const iframe = createIframe();
        document.body.appendChild(iframe);
        const iframeDoc = iframe.contentDocument ? iframe.contentDocument : iframe.document;

        iframeDoc.open();
        iframeDoc.write('<html><head><title>e-planning</title></head><body></body></html>');
        iframeDoc.close();

        let script = iframeDoc.createElement('SCRIPT');
        script.src = `${this.scheme}://${baseUrl ? baseUrl : GLOBAL_URL}/layers/epl-41.min.js`;
        iframeDoc.body.appendChild(script);

        if (!baseUrl) {
            script = iframeDoc.createElement('SCRIPT');
            script.src = `${this.scheme}://ads.e-planning.net/egc/4/39a8`;
            iframeDoc.body.appendChild(script);
        }
        
        return false;
    }

    _initSpace(container) {
        const idAttr = container.getAttribute(DATA_ATTR);
        const id = this._findPosition(idAttr);
        this._createSpace(container, id);
    }

    _createSpace(container, id) {
        const eplId = `eplAdDiv${id}`;
        if (container.querySelector(`#${eplId}`) == null) {
            const el = document.createElement('div');
            el.id = eplId;
            container.appendChild(el);
            const opts = { t: 1 };
            this.eplArgs.sOpts[id] = opts;
            this._showSpace(id);
        }
    }

    _showSpace(id, custom) {
        if (this._initialized()) {
            const epl = document.epl;
            if (custom) {
                epl.setCustomAdShow(id, this.eplArgs.custom[id]);
            }
            epl.showSpace(id);
        } else {
            setTimeout(() => {
                this._showSpace(id, custom);
            }, 250);
        }
    }

    _setupAd() {
        if (document.epl.eplReady()) return true;
        document.epl.eplInit(this.eplArgs);
        if (this.eplArgs.custom) {
            for (var s in this.eplArgs.custom) {
                document.epl.setCustomAdShow(s, this.eplArgs.custom[s]);
            }
        }
        return document.epl.eplReady();
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/EplAd.js